// extracted by mini-css-extract-plugin
module.exports = {"blue100":"#E2EBFF","frame":"IconFrame_frame__0fRDy","round":"IconFrame_round__sAkmO"};